export class SystemCompanySettings{
    companyIdCode:string = "";
    companyName:string = "";

    constructor(name:string, id:string) {
        this.companyIdCode = id;
        this.companyName = name;
    }
}